import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const DashboardApi = createApi({
  reducerPath: "DashboardApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["DASHBOARDAPI"],
  endpoints: (build) => ({
    getDashboardData: build.query({
      query: () => ({
        url: `/dashboard`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["DASHBOARDAPI"],
    }),
    getRecentActivity: build.query({
      query: () => ({
        url: "/dashboard/recent-activity",
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["DASHBOARDAPI"],
    }),
    getAnalytics: build.query({
      query: (dateRange) => ({
        url: `/dashboard/analytics?fromDate=${dateRange?.startDate}&toDate=${dateRange?.endDate}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["DASHBOARDAPI"],
    }),
    getPopularTests: build.query({
      query: () => ({
        url: `/search?action=popular`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["DASHBOARDAPI"],
    }),
    searchTests: build.query({
      query: ({ search, action = 'search' }) => ({
        url: `/search?action=${action}&search=${search}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["DASHBOARDAPI"],
    }),
  }),
});

export const {
  useGetDashboardDataQuery,
  useGetAnalyticsQuery,
  useGetRecentActivityQuery,
  useGetPopularTestsQuery,
  useSearchTestsQuery
} = DashboardApi;
